<template>
  <div class="form-wrap">
    <h1 class="blog-post-title-2">
      Sign Up To Get Live Trainings
    </h1>
    <form
      id="liveTrainingsForm" method="post"
      @submit.prevent="signUpLiveTrainings"
    >
      <div class="row">
        <div class="input-group col-6 col">
          <label for="email" class="required">Company email</label>
          <input
            id="email"
            v-model="email"
            type="text"
            name="email"
            autocomplete="email"
            placeholder="Company Email"
            :class="{ 'invalid-field': emailAlert }"
            @input="emailAlert = ''"
          >
          <small v-if="emailAlert" class="alert">{{ emailAlert }}</small>
        </div>
        <div class="input-group col-6 col">
          <label for="password" class="required">Password</label>
          <input
            id="password"
            v-model="password"
            :type="visiblePassword ? 'text' : 'password'"
            name="password"
            autocomplete="current-password"
            placeholder="Password"
            :class="{ password: !visiblePassword, 'invalid-field': passwordAlert }"
            @input="passwordAlert = ''"
            @keyup="validatePass"
          >
          <Component
            :is="visiblePassword ? 'IconEye' : 'IconEyeClosed'"
            class="icon-eye"
            @click="visiblePassword = !visiblePassword"
          />
          <small v-if="warningText" :class="warning" class="alert">{{ warningText }}</small>
        </div>
        <div class="input-group col-6 col">
          <label for="firstName" class="required">First Name</label>
          <input
            id="firstName"
            v-model="firstName"
            type="text"
            name="firstName"
            autocomplete="name"
            placeholder="Your First Name"
            :class="{ 'invalid-field': firstNameAlert }"
            @input="firstNameAlert = ''"
          >
          <small v-if="firstNameAlert" class="alert">{{ firstNameAlert }}</small>
        </div>
        <div class="input-group col-6 col">
          <label for="lastName" class="required">Last Name</label>
          <input
            id="lastName"
            v-model="lastName"
            type="text"
            name="lastName"
            autocomplete="name"
            placeholder="Your Last Name"
            :class="{ 'invalid-field': lastNameAlert }"
            @input="lastNameAlert = ''"
          >
          <small v-if="lastNameAlert" class="alert">{{ lastNameAlert }}</small>
        </div>
        <div class="input-group col-12 col">
          <label for="companyName" class="required">Company Name</label>
          <input
            id="companyName"
            v-model="companyName"
            type="text"
            name="companyName"
            autocomplete="organization"
            placeholder="Company Name"
            @input="companyNameAlert = ''"
          >
          <small v-if="companyNameAlert" class="alert">{{ companyNameAlert }}</small>
        </div>
        <div class="input-group col-6 col">
          <label for="companyId" class="required">Company ID</label>
          <input
            id="companyId"
            v-model="companyId"
            type="text"
            name="companyId"
            placeholder="Company ID"
            @input="companyIdAlert = ''"
          >
          <small v-if="companyIdAlert" class="alert">{{ companyIdAlert }}</small>
        </div>
        <div class="input-group col-6 col">
          <label for="vat">EU/UK VAT Number (optional)</label>
          <input
            id="vat" v-model="vat" type="text"
            name="vat"
            autocomplete="organization"
            placeholder="VAT Number"
            :class="{ 'invalid-field': vatAlert }"
            @input="vatAlert = ''"
          >
          <small v-if="vatAlert" class="alert">{{ vatAlert }}</small>
        </div>
        <div class="input-group col-6 col">
          <div class="country">
            <label class="required">Country</label>
            <select
              v-model="country"
              class="form-control"
              :class="{ selected: country }"
              @change="countryPhone"
            >
              <option disabled hidden value="">
                Country
              </option>
              <option
                v-for="(c, id) in countries"
                :key="id"
                :value="c.alpha2"
              >
                {{ c.country }}
              </option>
            </select>
            <small v-if="countryAlert" class="alert">{{ countryAlert }}</small>
          </div>
        </div>
        <div class="input-group col-6 col">
          <label for="phone">Phone number (optional)</label>
          <input
            id="phone"
            v-model="phone"
            type="text"
            name="phone"
            placeholder=""
          >
        </div>
        <div class="input-group col-6 col">
          <div class="company-size">
            <label class="required">Company size</label>
            <select
              v-model="companySize"
              class="form-control"
              :class="{ selected: companySize }"
              @change="companySizeAlert = ''"
            >
              <option disabled hidden value="">
                Company Size
              </option>
              <option
                v-for="(size, id) in sizes"
                :key="id"
                :value="size"
              >
                {{ size }}
              </option>
            </select>
            <small v-if="companySizeAlert" class="alert">{{ companySizeAlert }}</small>
          </div>
        </div>
        <div class="input-group col-6 col">
          <div class="industry">
            <label class="required">Industry</label>
            <select
              v-model="industry"
              class="form-control"
              :class="{ selected: industry }"
              @change="industryAlert = ''"
            >
              <option disabled hidden value="">
                Industry
              </option>
              <option
                v-for="(ind, id) in industries"
                :key="id"
                :value="ind"
              >
                {{ ind }}
              </option>
            </select>
            <small v-if="industryAlert" class="alert">{{ industryAlert }}</small>
          </div>
        </div>
      </div>
      <div class="form-footer">
        <div class="input-group col-12 terms-holder">
          <div :class="{ error: termsAgreedAlert }">
            <input
              id="terms" v-model="termsAgreed" type="checkbox"
              class="custom-checkbox reverse-colors"
              @change="termsAgreedAlert = false"
            >
            <label for="terms" class="terms">
              I agree to 365 Data Science’s <a target="_blank" href="https://365datascience.com/terms-of-use/">Terms of Use</a> & <a target="_blank" href="https://365datascience.com/privacy-policy/">Privacy Policy</a>
            </label>
          </div>
          <small v-if="termsAgreedAlert" class="alert alert-privacy">Please accept the Privacy Policy to sign up</small>
        </div>
        <div class="col-12 btn-holder">
          <button
            class="btn-primary btn-lg"
            type="submit"
            :disabled="!canRegister"
          >
            Sign Up
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { COUNTRIES } from '@itbpbg/lms-components/src/utils/constants';
import IconEye from '../assets/svg/eye.svg?vue-component';
import IconEyeClosed from '../assets/svg/eye-closed.svg?vue-component';
import { COUNTRY_PHONE } from '../utils/constants';

export default {
  components: {
    IconEye,
    IconEyeClosed,
  },
  data() {
    return {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      companyName: '',
      companyId: '',
      vat: '',
      country: '',
      phone: '',
      companySize: '',
      industry: '',
      termsAgreed: false,
      sizes: [
        '5-10',
        '11-20',
        '21-50',
        '51-100',
        '101-500',
        '501-1000',
        '1000+',
      ],
      industries: [
        'Accounting',
        'Advertising, Arts & Media',
        'Automotive',
        'Banking & Financial Services',
        'Call Centre & Customer Service',
        'Computer software',
        'Construction, Design, Architecture',
        'Education & Training',
        'Elecronics',
        'Engineering',
        'Farming, Animals & Conservation',
        'Government & Defence',
        'Healthcare & Medical',
        'Hospitality & Tourism',
        'Human Resources & Recruitment',
        'Information & Communication Technology',
        'Insurance & Superannuation',
        'Legal',
        'Manufacturing, Transport & Logistics',
        'Marketing & Communications',
        'Mining, Resources & Energy',
        'Real Estate & Property',
        'Retail & Consumer Products',
        'Science & Technology',
        'Sport & Recreation',
        'Other',
      ],
      emailAlert: '',
      warningText: '',
      passwordAlert: '',
      firstNameAlert: '',
      lastNameAlert: '',
      companyNameAlert: '',
      companyIdAlert: '',
      vatAlert: '',
      countryAlert: '',
      companySizeAlert: '',
      industryAlert: '',
      termsAgreedAlert: '',
      visiblePassword: false,
      warning: '',
    };
  },
  computed: {
    countries() {
      return COUNTRIES.sort((a, b) => a.country.localeCompare(b.country));
    },
    canRegister() {
      return this.email
      && this.password
      && this.firstName
      && this.lastName
      && this.companyName
      && this.companyId
      && this.country
      && this.companySize
      && this.industry
      && this.termsAgreed;
    },
  },
  methods: {
    validatePass() {
      if (this.password !== '') {
        // If the password length is less than or equal to 6
        if (this.password.length < 6) {
          this.warning = 'short';
          this.warningText = 'Too short';
          this.passwordAlert = true;
        }
        // If the password length is greater than 6 and contain any lowercase alphabet or any number or any special character
        if (
          this.password.length >= 6
          && (this.password.match(/[a-z]/)
            || this.password.match(/\d+/)
            || this.password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/))
        ) {
          this.warning = 'weak';
          this.warningText = 'Weak password';
          this.passwordAlert = false;
        }
        // If the password length is greater than 6 and contain alphabet,number,special character respectively
        if (
          this.password.length >= 6
          && ((this.password.match(/[a-z]/) && this.password.match(/\d+/))
            || (this.password.match(/\d+/)
              && this.password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/))
            || (this.password.match(/[a-z]/)
              && this.password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/)))
        ) {
          this.warning = 'good';
          this.warningText = 'Good password';
          this.passwordAlert = false;
        }
        // If the password length is greater than 6 and must contain alphabets,numbers and special characters
        if (
          this.password.length >= 6
          && this.password.match(/[a-z]/)
          && this.password.match(/\d+/)
          && this.password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/)
        ) {
          this.warning = 'strong';
          this.warningText = 'Strong password';
          this.passwordAlert = false;
        }
      } else {
        this.warning = '';
        this.warningText = '';
        this.passwordAlert = true;
      }
    },
    countryPhone() {
      this.countryAlert = '';
      this.phone = COUNTRY_PHONE[this.country];
    },
    async signUpLiveTrainings() {
      try {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!this.email || !re.test(this.email)) {
          this.emailAlert = 'Invalid email';
          return;
        }

        this.validatePass();
        if (this.passwordAlert) {
          this.warning = 'short';
          this.warningText = 'Minimum password length is 6 symbols ';
          return;
        }

        if (!this.firstName) {
          this.firstNameAlert = 'Required field';
          return;
        }

        if (!this.lastName) {
          this.lastNameAlert = 'Required field';
          return;
        }

        if (!this.companyName) {
          this.companyNameAlert = 'Required field';
          return;
        }

        if (!this.companyId) {
          this.companyIdAlert = 'Required field';
          return;
        }

        if (!this.country) {
          this.countryAlert = 'Required field';
          return;
        }

        if (!this.companySize) {
          this.companySizeAlert = 'Required field';
          return;
        }

        if (!this.industry) {
          this.industryAlert = 'Required field';
          return;
        }

        if (!this.termsAgreed) {
          this.termsAgreedAlert = 'Required field';
          return;
        }

        const data = {
          email: this.email,
          password: this.password,
          companyName: this.companyName,
          companyId: this.companyId,
          country: this.country,
          companySize: this.companySize,
          industry: this.industry,
          name: `${this.firstName} ${this.lastName}`,
          phone: this.phone,
          vat: this.vat,
        };

        const signup = await this.$axios.$post('/business/admin/signup/?liveTrainings=true', data, { noError: true }).catch((e) => e.response.data);

        if (signup && signup.error === 'emailAlreadyTaken') {
          this.emailAlert = 'This email is already registered. Please log in.';
          return;
        }

        if (signup && signup.error === 'vatInvalid') {
          this.vatAlert = 'Invalid Vat Number';
          return;
        }

        if (signup && signup.accessToken && signup.refreshToken) {
          this.$store.dispatch('auth/setUserInfo', signup.user);
          this.$redirectAfterLogin('/');
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.form-wrap {
  background-color: var(--main-light);
  border-radius: 10px;
  box-shadow: 0 16px 30px rgba(0, 12, 31, 0.08);
  color: var(--main-dark-shade-0);
  padding: 64px;
  width: 100%;
  margin: auto;

  .blog-post-title-2 {
    margin-bottom: var(--spacing-24);
  }

  .input-group {
    margin-bottom: var(--spacing-24);

    input.invalid-field {
      border-color: var(--main-red);
    }

    label {
      font-size: 14px;
    }

    label + input {
      margin-top: 5px;
    }

    .alert {
      position: absolute;
      bottom: -20px;
      padding-left: 0;
      color: var(--main-red);

      &.alert-privacy {
        position: static;
        text-align: center;
        display: block;
        padding: 0;
        margin-top: var(--spacing-8);
        height: 40px;
        line-height: 40px;
        background-color: var(--main-red-light-2);
        border: 1px solid var(--main-red-light-3);
        border-radius: 5px;
        color: var(--main-red-shade-1);
      }
    }

    .icon-eye {
      cursor: pointer;
      position: absolute;
      right: var(--spacing-24);
      top: calc(50%);
    }

    small {
      color: var(--main-red);
      padding-left: 26px;

      &.short,
      &.weak,
      &.error {
        color: var(--main-red);
      }

      &.good {
        color: var(--accent) !important;
      }

      &.strong {
        color: var(--main-green-shade-1) !important;
      }
    }

    .terms {
      color: var(--main-light-shade-4);

      a {
        color: var(--accent);
      }
    }
  }

  .form-footer {
    display: flex;
    flex-direction: column;
  }

  .country,
  .company-size,
  .industry {
    width: 100%;
    position: relative;

    svg {
      position: absolute;
      top: 50%;
      right: 21px;
      width: 14px;
      height: 8px;
      transform: translateY(50%);
      margin-top: 5px;

      path[stroke] {
        stroke: var(--main-light-shade-4);
      }
    }

    select {
      margin-top: 5px;
      background-image: url('../assets/svg/arrow-down-b2b-sales.svg');
      background-position: center right 14px;
      border: 1px solid rgba(0, 12, 31, 0.18);
      border-radius: 5px;
      padding-right: 40px;
      overflow: hidden;
      text-overflow: ellipsis;

      &:not(.selected) {
        color: var(--main-light-shade-4);
      }

      option {
        color: var(--main-dark-shade-0);
      }
    }
  }

  .btn-primary {
    width: 100%;
    max-width: 300px;
    font-size: 18px;
    font-weight: 600;
  }
}

@include bp($bp-laptop) {
  .form-wrap .btn-primary {
    max-width: 225px;
  }
}

@include bp($bp-mobile) {
  .form-wrap {
    border-radius: 0;
    padding: var(--spacing-80) var(--spacing-24);

    .blog-post-title-2 {
      text-align: center;
      margin-bottom: var(--spacing-36);
    }

    .terms-holder {
      margin: 0;
    }

    .btn-holder {
      order: -1;
      margin: var(--spacing-12) 0 var(--spacing-16);
    }
  }
}

</style>
